export default class sortService {
    compareFun(a, b, type = 'string') {
        switch (type) {
        case 'num': // 数字排序
            return a - b
            break
        case 'date': // 日期排序
            return new Date(a.split('-').join('/')).getTime() - new Date(b.split('-').join('/')).getTime()
            break
        default: // 字符串排序
            return a.localeCompare(b)
        }
    }
}



// WEBPACK FOOTER //
// ./src/common/services/querySortService.js